import { closeSnackbar, SnackbarKey } from "notistack";

import { IconButton } from "ui/components/IconButton";
import { SVG } from "ui/components/SVG";
import { CLOSE_ICON_URL } from "ui/constants/icons";

export const CloseIconButton = ({
  snackbarId,
}: {
  snackbarId: SnackbarKey;
}) => {
  const onClick = () => {
    closeSnackbar(snackbarId);
  };

  return (
    <IconButton variant="icon" onClick={onClick}>
      <SVG src={CLOSE_ICON_URL} size={18} />
    </IconButton>
  );
};

export const renderCloseIconButton = (snackbarId: SnackbarKey) => (
  <CloseIconButton snackbarId={snackbarId} />
);
